/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { EmailRecipientDto } from './email-recipients.model';

export const EmailRecipientMapper = entity<EmailRecipientDto>({});
